import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'redux-form'
import fieldProps from '../fieldProps'
import Svg from 'components/util/Svg'
import classnames from 'classnames'
import switchStyles from './_checkboxSwitch.css'
import buttonStyles from './_checkboxButton.css'
import FieldError from '../FieldError'

export function CheckboxField (props) {
  const {
    input,
    meta,
    labelComponent,
    errorComponent,
    required,
    disabled,
    button,
    inputIconContainerClassName,
  } = props
  const { name } = input
  const selected = !!input.value
  const styles = button ? buttonStyles : switchStyles

  const handleChange = (evt) => {
    props.input.onChange(evt)
    props.onChange(evt)
  }

  return (
    <div className={props.className}>
      <label
        htmlFor={name}
        className={classnames(styles.container, {
          [styles.disabled]: disabled,
          [styles.selected]: selected,
        })}
      >

        {!button ?
          <div className={classnames(styles.iconContainer, inputIconContainerClassName)}>
            <Svg name='radio_check' className={styles.icon} />
          </div>
        : null}

        <input
          {...input}
          className={styles.input}
          id={name}
          type='checkbox'
          checked={selected}
          onChange={handleChange}
          disabled={disabled}
        />

        {labelComponent ?
          <div className={styles.label}>
            {React.cloneElement(labelComponent, { selected: selected })}
            {required && <b className={styles.required}>{'*'}</b>}
          </div>
        : null}

        {button ?
          <Svg name='radio_check' className={styles.icon} />
        : null}

      </label>

      {(meta.touched && meta.error && errorComponent) ?
        <FieldError
          errorComponent={errorComponent}
          showError={!!(meta.touched && meta.error)}
          errorMessage={meta.error}
        />
      : null}

    </div>
  )
}

CheckboxField.propTypes = fieldProps

CheckboxField.defaultProps = {
  onChange: () => {},
}

export const renderField = (field) => (
  <CheckboxField {...field} />
)

export const FieldWrapper = ({ ...props }) => (
  <Field {...props} component={renderField} />
)

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.node,
  label: PropTypes.node,
  disabled: PropTypes.bool,
}

export default FieldWrapper
